import { z } from 'zod';

export const placeCategorySchema = z.object({
    documentId: z.string(),
    slug: z.string(),
    name: z.string(),
    description: z.any(),
    images: z.array(
        z.object({
            url: z.string(),
        }),
    ).nullable().optional(),
    format: z.object({
        name: z.string(),
    }).nullable().optional(),
});
